import axios from 'axios'
import API from '@/services/API/api'

export default async (ticket_number,pos_sale_type) => {
    try {
        console.log(API.TICKET_NEXT)
        //console.log(posCashDeskId)
        let response = await axios.get(API.TICKET_NEXT, {
            params: { 
                document_number: ticket_number,
                document_type: pos_sale_type 
            },
        })
        console.log('RESPONSE:')
        console.log(response.data)
        return response.data
    } catch (error) {
        console.log('ERROR:')
        console.log(error)
        return error.response
    }
}
